import { Cookies } from "react-cookie"

const cookies = new Cookies()
let csrftoken = cookies.get("csrftoken")
if (!csrftoken)
  if (typeof window !== `undefined`)
    csrftoken = window.djangoConstants.csrftoken

const prefix = "/api"

const headers = () => ({
  credentials: "include",
  headers: {
    "X-CSRFToken": csrftoken,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

const post = (url, data) =>
  fetch(prefix + url, {
    ...headers(),
    method: "POST",
    body: JSON.stringify(data),
  }).then(response => {
    const contentType = response.headers.get("content-type")
    let returnData
    if (contentType && contentType.includes("application/json")) {
      returnData = response.json()
    } else {
      returnData = response
    }

    if (!response.ok) {
      // eslint-disable-next-line no-throw-literal
      throw {
        status: response.status,
        data: returnData,
      }
    }
    if (response.redirected === true) {
      window.location.href = data.url
      return null
    }

    return returnData
  })

export default {
  post,
}
